import { httpClient } from '@/shared/services/httpClient';
import { ITestFlow } from '@/shared/types/ITestFlow';

export const getTestFlow = (payload: { testCanonicalId: string, locale: string }) => httpClient.rainbow
  .get(`public/test-flow/${payload.testCanonicalId}?locale=${payload.locale}`)
  .then((res): ITestFlow => res.data as ITestFlow)
  .catch(error => {
    throw error;
  });

export const getLinkInfo = (linkId: string): Promise<any> => httpClient.access
  .get(`public/links-manager/${linkId}`)
  .then(res => res.data)
  .catch(error => {
    throw error;
  });

export const getLatestMatchingLinkInfo = (linkId: string): Promise<any> => httpClient.access
  .get(`public/links-manager/latest-matching/${linkId}`)
  .then(res => res.data)
  .catch(error => {
    throw error;
  });

export const getDynamicConfig = (): Promise<any> => httpClient.client
  .get('/api/v1/access/public/captcha/key')
  .then(res => res.data)
  .catch(error => {
    throw error;
  });
